import React from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { GitCompare, X } from "lucide-react";
import { useCompare } from "../lib/compareStore";
import { getMotorBySlug } from "../data/motorcycles";

export default function CompareBar() {
  const { slugs, clear, remove } = useCompare();
  const items = slugs.map(getMotorBySlug).filter(Boolean);

  return (
    <AnimatePresence>
      {items.length > 0 && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 320, damping: 30 }}
          className="fixed bottom-20 left-3 right-3 sm:left-auto sm:right-4 sm:bottom-20 z-40 rounded-2xl bg-white border border-slate-200 shadow-2xl sm:max-w-md"
          data-testid="compare-bar"
        >
          <div className="p-3 flex items-center gap-3">
            <div className="flex -space-x-2 shrink-0">
              {items.map((m) => (
                <div
                  key={m.slug}
                  className="relative w-10 h-10 rounded-lg bg-white border border-slate-200 overflow-hidden group"
                >
                  <img src={m.image} alt={m.name} className="w-full h-full object-contain p-0.5" />
                  <button
                    onClick={() => remove(m.slug)}
                    data-testid={`compare-remove-${m.slug}`}
                    aria-label="Hapus"
                    className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-slate-800 text-white opacity-0 group-hover:opacity-100 flex items-center justify-center transition"
                  >
                    <X className="w-2.5 h-2.5" />
                  </button>
                </div>
              ))}
              {Array.from({ length: 3 - items.length }).map((_, i) => (
                <div
                  key={`ph-${i}`}
                  className="w-10 h-10 rounded-lg border-2 border-dashed border-slate-200 bg-slate-50 flex items-center justify-center text-slate-300 text-xs"
                >
                  +
                </div>
              ))}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold text-slate-900">
                {items.length} motor dibandingkan
              </p>
              <p className="text-[10px] text-slate-500 truncate">
                {items.map((m) => m.name).join(" · ")}
              </p>
            </div>
            <div className="flex items-center gap-1">
              {items.length >= 2 && (
                <Link
                  to="/compare"
                  data-testid="compare-open"
                  className="inline-flex items-center gap-1 px-3 py-2 rounded-full bg-[#002d62] hover:bg-[#001a3f] text-white text-xs font-semibold transition"
                >
                  <GitCompare className="w-3.5 h-3.5" /> Bandingkan
                </Link>
              )}
              <button
                onClick={clear}
                data-testid="compare-clear"
                aria-label="Kosongkan"
                className="w-8 h-8 rounded-full border border-slate-200 text-slate-500 hover:text-slate-800 hover:border-slate-300 flex items-center justify-center transition"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
          {items.length < 2 && (
            <p className="px-3 pb-2.5 text-[10px] text-slate-500">
              Tambahkan minimal 2 motor untuk membandingkan.
            </p>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
